import { useSelector } from "react-redux";
import { ContainerBot } from "../components/ContainerBot/ContainerBot";
import { Navbar } from "../components/Navbar/Navbar";
import { ProgressBar } from "../components/ProgressBar/ProgressBar";
//import { useEffect } from "react";
//import FirebaseStripeService from "../firebase-service/FirebaseStripe";
//import { openSaasRedux } from "../actions/openSaas.actions";
import { ReportReady } from "../components/ReportComponent/ReportReady";
import { ReportSubmited } from "../components/ReportComponent/ReportSubmited";

export const HomePage = () => {
  const formDataDic = useSelector((state) => state.formDataDic);
  /*const dispatch = useDispatch();

  useEffect(() => {
    const updateStatus = (bool) => {
      dispatch(openSaasRedux(bool));
    };
    FirebaseStripeService.getPremiumStatus(
      formDataDic?.uid ? formDataDic?.uid : "javanaise",
      updateStatus
    );
  }, [formDataDic, dispatch]);*/
  return (
    <>
      <Navbar />
      {formDataDic?.isAllowed && (
        <div className="m-2">
          <ReportReady />
        </div>
      )}
      {formDataDic?.isAllowed === false && formDataDic?.isSubmited === true && (
        <div className="m-2">
          <ReportSubmited />
        </div>
      )}
      {formDataDic?.isAllowed === false &&
        formDataDic?.isSubmited === false && (
          <div className=" flex flex-col justify-start m-2 gap-2">
            <ProgressBar />
            <div role="alert" className="alert alert-warning mt-4 p-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <span className="text-xs">
                Note: Si vous ne savez pas répondre à la question, mettez juste:
                "je ne sais pas"
              </span>
            </div>
            <ContainerBot />
          </div>
        )}
    </>
  );
};
